import { Hub } from 'aws-amplify'
import Auth from '@aws-amplify/auth'
import GroupsToPermissions from './groups-to-permissions'

const HookUser = (store) => {
  if (process.env.VUE_APP_DEV_FORCE_LOGIN === 'true') {
    let fakeUserInformations = JSON.parse(process.env.VUE_APP_DEV_FORCE_USER_INFORMATION)
    store.commit('user/setFirstName', fakeUserInformations.firstName)
    store.commit('user/setLastName', fakeUserInformations.lastName)
    store.commit('user/setDisplayName', fakeUserInformations.displayName)
    store.commit('user/setEmail', fakeUserInformations.email)
    return GroupsToPermissions('AwsCognito', fakeUserInformations.groups)
      .then((response) => {
        store.commit('user/setCredentials', response)
        store.commit('user/setLogged', true)
      })
  }
  let loadUserData = () => {
    Auth.currentAuthenticatedUser({ bypassCache: false })
      .then((user) => {
        store.commit('user/setFirstName', user.attributes.given_name)
        store.commit('user/setLastName', user.attributes.family_name)
        store.commit('user/setDisplayName', user.attributes.given_name + ' ' + user.attributes.family_name)
        store.commit('user/setEmail', user.attributes.email)
        store.commit('user/setCredentials', user.signInUserSession.idToken.payload['permissions'] ? user.signInUserSession.idToken.payload['permissions'].split(',') : [])
        store.commit('user/setLogged', true)
      })
      .catch(() => {
        store.commit('user/setLogged', false)
      })
  }
  Hub.listen('auth', (data) => {
    if (data.payload.event === 'signOut') {
      store.commit('user/setLogged', false)
      // Force reload to home to empty all state
      document.location.href = '/logout'
      return
    }
    if (data.payload.event === 'signIn') {
      loadUserData()
      return
    }
    console.log('data.payload', data.payload)
    console.log('A new auth event has happened: ', data.payload.data.username + ' has ' + data.payload.event)
  })
  loadUserData()
}

export default HookUser
